// extracted by mini-css-extract-plugin
export default {"container":"U06R5X","title":"JgUGmk","textButton":"PNfN9H"};